<template>
    <tr :class="{'ix-table-row-hidden-from-client': (canHide || showsHiddenFlag) && prediction.is_hidden_from_client, 'ix-service-block-row': prediction.service_block, 'ix-service-block-header': prediction.service_block && prediction.is_title == 1}">
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td class="text-center">
            <!-- En-tête de prestation : reste un titre -->
            <input type="hidden" v-if="isServiceHeader" :name="'predictions[' + index + '][is_title]'" value="1">
            <input type="checkbox" v-else value="1" :id="'is_title_' + prediction.uniq" :name="'predictions[' + index + '][is_title]'" v-model="prediction.is_title" @change="compute">
        </td>
        <td>
            <select :name="'predictions[' + index + '][type]'" v-model="prediction.type" class="form-control form-control-sm" :required="!prediction.is_title && prediction.designation != '' && prediction.designation != null" v-show="!prediction.is_title" @change="fillAttributeWithDefault">
                <option value="">Choisir une catégorie</option>
                <option v-for="(type, value) in types" :value="type.value">{{ type.label }}</option>
            </select>

            <select :name="'predictions[' + index + '][type_secondary]'" v-model="prediction.type_secondary" class="form-control form-control-sm mt-2" required v-if="prediction.type == 2">
                <option value="">Choisir une sous-catégorie</option>
                <option v-for="(type, value) in purchaseTypes" :value="type.value">{{ type.label }}</option>
            </select>
            <span class="ix-service-block-badge" v-if="isServiceHeader">Bordereau</span>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'predictions[' + index + '][reference]'" v-model="prediction.reference">
        </td>
        <td>
            <!-- En-tête de prestation : nom et accès à la modification -->
            <div class="ix-service-block-title" v-if="isServiceHeader">
                <span class="ix-service-block-name">{{ serviceName }}</span>
                <button type="button" class="ix-service-block-edit" @click="$emit('edit-service-block', prediction)"><i class="far fa-pen"></i> Modifier la prestation</button>
                <input type="hidden" :name="'predictions[' + index + '][designation]'" :value="prediction.designation">
            </div>
            <div class="input-group" v-else>
                <div class="input-group-prepend" v-if="prediction.article_id">
                    <span class="input-group-text"><i class="far fa-cube"></i></span>
                </div>  
                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + prediction.uniq" type="text" :name="'predictions[' + index + '][designation]'" v-model="prediction.designation" @input="emitEventPredictionEdited" :required="prediction.type != ''">
            </div>
            <span class="ix-badge optional mt-1" v-if="prediction.is_optional">Option</span>
            <span class="badge badge-secondary mt-1" v-if="prediction.service_block && prediction.is_title != 1 && prediction.unit === 'forfait'">Forfait</span>
            <input type="hidden" :name="'predictions[' + index + '][id]'" v-model="prediction.id">
            <input type="hidden" :name="'predictions[' + index + '][article_id]'" v-model="prediction.article_id">
            <!-- Lien avec la prestation de bordereau insérée (bloc modifiable) -->
            <template v-if="prediction.service_block">
                <input type="hidden" :name="'predictions[' + index + '][service_block]'" :value="prediction.service_block">
                <input type="hidden" :name="'predictions[' + index + '][service_list_id]'" :value="prediction.service_list_id">
                <input type="hidden" :name="'predictions[' + index + '][service_quantity]'" :value="prediction.service_quantity">
                <input type="hidden" :name="'predictions[' + index + '][service_unit]'" :value="prediction.service_unit">
                <input type="hidden" :name="'predictions[' + index + '][service_unit_quantity]'" :value="prediction.service_unit_quantity">
            </template>
            <input type="hidden" v-if="canHide" :name="'predictions[' + index + '][is_hidden_from_client]'" :value="prediction.is_hidden_from_client ? 1 : 0">
            <input type="hidden" :name="'predictions[' + index + '][is_optional]'" :value="prediction.is_optional ? 1 : ''" v-if="canToggleOptional || prediction.is_optional">
            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" placeholder="description, informations complémentaires, .." :name="'predictions[' + index + '][description]'" v-model="prediction.description"></textarea>
            </div>
        </td>
        <!-- En-tête de prestation : quantité, PR total, PV par unité et total du bloc -->
        <template v-if="isServiceHeader">
            <td class="ix-text-bold ix-nowrap">{{ formatNumber(prediction.service_quantity, 3) }} {{ serviceUnit }}</td>
            <td class="text-right ix-text-secondary ix-nowrap">{{ currency(serviceTotal) }}</td>
            <td></td>
            <td class="text-right ix-text-secondary ix-nowrap">{{ currency(serviceUnitSelling) }}<span v-if="serviceUnit"> / {{ serviceUnit }}</span></td>
            <td class="text-right ix-text-bold ix-nowrap">{{ currency(serviceTotalSelling) }}</td>
        </template>
        <td colspan="5" v-else-if="prediction.is_title == 1"></td>
        <td v-if="prediction.is_title != 1">
            <div v-bind:class="{'input-group': prediction.type == 1 || prediction.type == 4}">
                <input type="number" class="form-control form-control-sm" :name="'predictions[' + index + '][quantity]'" v-model="prediction.quantity" @blur="compute" required step="0.001" :readonly="prediction.service_block && prediction.unit === 'forfait'">
                <div class="input-group-append" v-if="prediction.type == 1 || prediction.type == 4">
                    <span class="input-group-text" id="inputGroup-sizing-sm">h</span>
                </div>
            </div>
            <input type="text" class="form-control form-control-sm mt-2" placeholder="unité" :name="'predictions[' + index + '][unit]'" v-model="prediction.unit" v-show="is_expanded === true" v-if="prediction.type != 1 && prediction.type != 4">
            <!-- Ligne de prestation : rappel du calcul de la quantité -->
            <small class="ix-service-block-formula" v-if="prediction.service_block">{{ serviceFormula }}</small>
            <!-- Quantité recalculée avec celle de l'étude : ancienne quantité et facteur -->
            <small class="ix-lot-scaled" v-if="prediction.scaled_from !== undefined && prediction.scaled_from !== null">
                <s>{{ formatNumber(prediction.scaled_from, 3) }}</s> <span class="ix-lot-scaled-factor">×{{ formatNumber(prediction.scaled_factor, 4) }}</span>
            </small>
        </td>
        <td v-if="prediction.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'predictions[' + index + '][amount]'" v-model="prediction.amount" @change="compute(null)" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                        € <span v-if="prediction.type == 1 || prediction.type == 4">&nbsp;/ h</span>
                    </span>
                </div>
            </div>
        </td>
        <td v-if="prediction.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(prediction.margin) < 0 }" :name="'predictions[' + index + '][margin]'" v-model="prediction.margin" @change="compute('margin')" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>
        </td>
        <td v-if="prediction.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'predictions[' + index + '][selling]'" v-model="prediction.selling" @change="compute('selling')" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                        € <span v-if="prediction.type == 1 || prediction.type == 4">&nbsp;/ h</span>
                    </span>
                </div>
            </div>
        </td>
        <td class="text-right" v-if="prediction.is_title != 1">{{ currency(prediction.total_selling) }}</td>
        <td class="text-center" v-if="remaining">
            <input type="checkbox" v-model="prediction.remaining_selected"  v-if="prediction.is_title != 1" @change="updateRemaining()"/>

             <span data-toggle="tooltip" class="ml-2" style="font-size:14px !important" data-placement="top" title="Prévision déjà injectée dans le reste à faire" v-show="prediction.has_remaining">
                <i class="far fa-check-square" style="color: green"></i>
            </span>


             <span data-toggle="tooltip" class="ml-2" style="font-size:14px !important" data-placement="top" title="Prévision non injectée dans le reste à faire" v-show="!prediction.has_remaining && prediction.is_title != 1">
                <i class="far fa-exclamation-square" style="color: orange" ></i>
            </span>


            <input type="hidden" :name="'predictions[' + index + '][remaining]'" v-model="prediction.sync_remaining" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][amount]'" v-if="prediction.remaining_selected" v-model="prediction.amount" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][quantity]'" v-if="prediction.remaining_selected" v-model="prediction.quantity" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][selling]'" v-if="prediction.remaining_selected" v-model="prediction.selling" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][type]'" v-if="prediction.remaining_selected" v-model="prediction.type" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][margin]'" v-if="prediction.remaining_selected" v-model="prediction.margin" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][designation]'" v-if="prediction.remaining_selected" v-model="prediction.designation" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][total]'" v-if="prediction.remaining_selected" v-model="prediction.total" />
        </td>
        <!-- Les icônes d'action restent sur une ligne -->
        <td class="text-right text-nowrap">
            <span class="btn btn-sm transparent" v-if="canHide" @click="toggleHiddenFromClient"
                v-b-tooltip.hover :title="prediction.is_hidden_from_client ? 'Ligne masquée dans le devis : cliquer pour l\'afficher' : 'Masquer cette ligne dans le devis'">
                <i class="far" :class="prediction.is_hidden_from_client ? 'fa-eye-slash' : 'fa-eye'"></i>
            </span>
            <span class="btn btn-sm transparent" v-else-if="showsHiddenFlag"
                v-b-tooltip.hover title="Ligne masquée dans le devis (masquage désactivé dans les paramètres)">
                <i class="far fa-eye-slash"></i>
            </span>

            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <span class="btn btn-sm transparent" v-if="canToggleOptional" @click="$emit('prediction-toggle-optional', prediction)"
                  :title="prediction.is_optional ? 'En option : cliquer pour repasser en prévision normale' : 'Mettre en option'">
                <i class="fas" :class="prediction.is_optional ? 'fa-toggle-on ix-option-toggle-on' : 'fa-toggle-off'"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventPredictionDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";

    import { marginBounds, isMarginInBounds } from './marginBounds';
    import serviceBlockLine from './serviceBlockLine';

    export default {
        name: 'prediction-form',
        mixins: [serviceBlockLine],
        // rows : lignes de l'étude (prestations) ; contextUnit : unité de l'étude
        props: ['prediction', 'index', 'suggestionsRoute', 'types', 'purchaseTypes', 'defaultMarginWorkforce', 'defaultMarginPurchases', 'defaultMarginStocks', 'defaultMarginEquipments', 'marginType', 'defaultHourlyRate', 'lot', 'lotIndex', 'manageRemaining', 'canHide', 'showsHiddenFlag', 'canToggleOptional', 'rows', 'contextUnit'],
        data() {
            return {
                errors: [],
                is_expanded: false,
                suggestions: [],
                currentLot : this.lot ? this.lot : null,
                remaining: this.manageRemaining ? this.manageRemaining : false,
                canUpdateRemaining : false,
            };
        },
        computed: {
            serviceRows: function () {
                return this.rows || [];
            },
            serviceContextUnit: function () {
                return this.contextUnit || '';
            },
            marginBounds: function() {
                return marginBounds(this.marginType);
            },
        },
        methods : {
            updateRemaining: function(){
                if(this.canUpdateRemaining)
                    this.prediction.sync_remaining = this.prediction.remaining_selected ? 1 : 0;

            },
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            toggleHiddenFromClient: function() {
                this.$set(this.prediction, 'is_hidden_from_client', !this.prediction.is_hidden_from_client);
            },
            fillAttributeWithDefault: function() {
                if (!this.prediction.designation) {
                    var margin = 0;
                    if (this.prediction.type == 1) {
                        this.prediction.amount = this.defaultHourlyRate
                        margin = this.defaultMarginWorkforce;
                    } else if(this.prediction.type == 2) {
                        margin = this.defaultMarginPurchases
                    } else if(this.prediction.type == 3) {
                        margin = this.defaultMarginStocks
                    } else if(this.prediction.type == 4) {
                        margin = this.defaultMarginEquipments
                    }

                    this.prediction.margin = margin
                    this.compute('margin')
                }
                
            },
            updateMargin: function(margin) {
                this.prediction.margin = margin
                this.compute('margin')
            },
            computeSelling: function () {
                // Taux hors bornes : prix de vente infini ou négatif, on conserve le prix actuel
                if (!isMarginInBounds(this.marginType, this.prediction.margin)) {
                    return this.prediction.selling
                }

                if (this.marginType == 2) {
                    return this.roundCurrency((parseFloat(this.prediction.amount)/(100 - parseFloat(this.prediction.margin))) * 100, 2)
                } else {
                    var marginTotal = (parseFloat(this.prediction.amount) / 100) * parseFloat(this.prediction.margin)
                    return this.roundCurrency((parseFloat(this.prediction.amount) + marginTotal), 2)
                }
            },
            computeMargin: function () {
                var marginDiff = parseFloat(this.prediction.selling) - parseFloat(this.prediction.amount)

                if (this.marginType == 2) {
                    if (parseFloat(this.prediction.selling) != 0) {
                        var divider = parseFloat(this.prediction.selling);
                    } else {
                        return 0;
                    }
                } else {
                    if (parseFloat(this.prediction.amount) != 0) {
                        var divider = parseFloat(this.prediction.amount);
                    } else {
                        return 0;
                    }
                }

                return this.roundCurrency((marginDiff/divider) * 100, 2)
            },
            compute: function(from) {
                // Prévention champs vide
                if (this.prediction.quantity == '' || this.prediction.quantity == null) { this.prediction.quantity = 0 }
                if (this.prediction.amount == '' || this.prediction.amount == null) { this.prediction.amount = 0 }
                if (this.prediction.total == '' || this.prediction.total == null) { this.prediction.total = 0 }
                if (this.prediction.margin == '' || this.prediction.margin == null) { this.prediction.margin = 0 }
                if (this.prediction.selling == '' || this.prediction.selling == null) { this.prediction.selling = 0 }
                if (this.prediction.article_id == '' || this.prediction.article_id == null) { this.prediction.article_id = null }

                if (this.prediction.is_title) {
                    this.prediction.type = ''
                    this.prediction.quantity = 1;
                    this.prediction.unit = '';
                    this.prediction.amount = 0;
                    this.prediction.total = 0;
                    this.prediction.margin = 0;
                    this.prediction.selling = 0;
                    this.prediction.total_selling = 0;
                    this.prediction.article_id = null;
                } else {
                    if (from == null || from == 'margin') {
                        this.prediction.selling = this.computeSelling()
                    } else if (from == 'selling') {
                        this.prediction.margin = this.computeMargin() 
                    }

                    this.prediction.total = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.amount)
                    this.prediction.total_selling = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.selling)

                    this.afterServiceQuantityInput(from);
                }
            },
            emitEventPredictionEdited: function () {
                this.$emit('prediction-editing-started', {
                    'index' : this.index,
                })
            },
            emitEventPredictionDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('prediction-deleted', {
                            'index' : this.index,
                        })
                    }
                })
            }
        },
        mounted() {
            // Expand si description
            if (this.prediction.description) {
                this.is_expanded = true;
            }

            if(!this.prediction.has_remaining)
                this.canUpdateRemaining = true;

            if (this.canHide) {
                this.$set(this.prediction, 'is_hidden_from_client', this.prediction.is_hidden_from_client == 1);
            }

            this.prediction.total = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.amount)
            this.prediction.total_selling = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.selling)

            //this.compute()

            var vm = this

            // Creation autocomplete
            $("#suggestionAutocomplete" + this.prediction.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term }, ...{deal_id: $('#deal_id').val()}},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_amount: this.currency(item.amount)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        return $('<li>')
                            .append(vm.studySuggestionItemHtml(item))
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){ 
                        this.prediction.article_id = null
                    }
                },
                select: (e, item) => {
                    this.prediction.reference = item.item.reference
                    this.prediction.designation = item.item.designation
                    this.prediction.unit = item.item.unit
                    this.prediction.amount = item.item.amount
                    this.prediction.selling = item.item.selling
                    this.prediction.description = item.item.description
                    this.prediction.is_title = item.item.is_title
                    this.prediction.lot_id = item.item.lot_id
                    this.prediction.article_id = item.item.article_id ? item.item.article_id : null;

                    if (this.prediction.article_id && this.prediction.is_title != 1) {
                        this.$set(this.prediction, 'is_hidden_from_client', false);
                    }

                    this.compute('selling');
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.prediction.uniq).autocomplete("search", '');
            });
        }
    }
</script>


<style>
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Pour Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>